import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";

// Portal público
import Inicio from "./pages/portal/Inicio";
import Listado from "./pages/portal/Listado";
import Detalle from "./pages/portal/Detalle";
import Contacto from "./pages/portal/Contacto";
import FichaPropiedad from "./pages/portal/FichaPropiedad";

// Admin
import Login from "./pages/admin/Login";
import Dashboard from "./pages/admin/Dashboard";
import Propiedades from "./pages/admin/Propiedades";
import PropiedadForm from "./pages/admin/PropiedadForm";
import Leads from "./pages/admin/Leads";
import Perfil from "./pages/admin/Perfil";
import Usuarios from "./pages/admin/Usuarios";
import Configuracion from "./pages/admin/Configuracion";
import Ciudades from "./pages/admin/Ciudades";
import Estados from "./pages/admin/Estados";
import AdminLayout from "./components/admin/AdminLayout";

const RutaPrivada = ({ children }) => {
  const { usuario, cargando } = useAuth();
  if (cargando) return <div className="spinner" style={{ marginTop: "40vh" }} />;
  return usuario ? children : <Navigate to="/admin/login" replace />;
};

export default function App() {
  return (
      <AuthProvider>
        <Routes>
          {/* Portal público */}
          <Route path="/" element={<Inicio />} />
          <Route path="/propiedades" element={<Listado />} />
          <Route path="/propiedades/:slug" element={<Detalle />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/propiedades/:slug/ficha" element={<FichaPropiedad />} />

          {/* Admin */}
          <Route path="/admin/login" element={<Login />} />
          <Route
              path="/admin"
              element={
                <RutaPrivada>
                  <AdminLayout />
                </RutaPrivada>
              }
          >
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="properties" element={<Propiedades />} />
            <Route path="properties/new" element={<PropiedadForm />} />
            <Route path="properties/:id/edit" element={<PropiedadForm />} />
            <Route path="contacts" element={<Leads />} />
            <Route path="usuarios" element={<Usuarios />} />
            <Route path="perfil" element={<Perfil />} />
            <Route path="configuracion" element={<Configuracion />} />
            <Route path="ciudades" element={<Ciudades />} />
            <Route path="estados" element={<Estados />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
  );
}